'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('banking-account-edit', {
      url: '/user/banking-accounts/edit/:id',
      template: '<banking-account-edit></banking-account-edit>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/user/banking-accounts/edit/banking-accounts-edit.routes.js